<app-shared-business-metadata-v2 [metadata]="metadata" />

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="!isLaaInfoEmpty(metadata) || !isLaaInfoEmpty(originalMetadata)"
>
  <div cardTitle i18n>Informations Assurance LAA</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          metadata?.professionalMenTotalSalary !== undefined ||
          originalMetadata?.professionalMenTotalSalary !== undefined
        "
      >
        <span class="card__label" i18n
          >Masse salariale accident professionnel hommes</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.professionalMenTotalSalary !==
                  metadata.professionalMenTotalSalary,
            }"
            >{{ metadata.professionalMenTotalSalary }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.professionalMenTotalSalary !==
                metadata.professionalMenTotalSalary &&
              originalMetadata.professionalMenTotalSalary !== null &&
              originalMetadata.professionalMenTotalSalary !== undefined
            "
            >{{ originalMetadata.professionalMenTotalSalary }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.professionalWomenTotalSalary !== undefined ||
          originalMetadata?.professionalWomenTotalSalary !== undefined
        "
      >
        <span class="card__label" i18n
          >Masse salariale accident professionnel femmes</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.professionalWomenTotalSalary !==
                  metadata.professionalWomenTotalSalary,
            }"
            >{{ metadata.professionalWomenTotalSalary }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.professionalWomenTotalSalary !==
                metadata.professionalWomenTotalSalary &&
              originalMetadata.professionalWomenTotalSalary !== null &&
              originalMetadata.professionalWomenTotalSalary !== undefined
            "
            >{{ originalMetadata.professionalWomenTotalSalary }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.nonProfessionalMenTotalSalary !== undefined ||
          originalMetadata?.nonProfessionalMenTotalSalary !== undefined
        "
      >
        <span class="card__label" i18n
          >Masse salariale accident non-professionnel hommes</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.nonProfessionalMenTotalSalary !==
                  metadata.nonProfessionalMenTotalSalary,
            }"
            >{{ metadata.nonProfessionalMenTotalSalary }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.nonProfessionalMenTotalSalary !==
                metadata.nonProfessionalMenTotalSalary &&
              originalMetadata.nonProfessionalMenTotalSalary !== null &&
              originalMetadata.nonProfessionalMenTotalSalary !== undefined
            "
            >{{ originalMetadata.nonProfessionalMenTotalSalary }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.nonProfessionalWomenTotalSalary !== undefined ||
          originalMetadata?.nonProfessionalWomenTotalSalary !== undefined
        "
      >
        <span class="card__label" i18n
          >Masse salariale accident non-professionnel femmes</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.nonProfessionalWomenTotalSalary !==
                  metadata.nonProfessionalWomenTotalSalary,
            }"
            >{{ metadata.nonProfessionalWomenTotalSalary }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.nonProfessionalWomenTotalSalary !==
                metadata.nonProfessionalWomenTotalSalary &&
              originalMetadata.nonProfessionalWomenTotalSalary !== null &&
              originalMetadata.nonProfessionalWomenTotalSalary !== undefined
            "
            >{{ originalMetadata.nonProfessionalWomenTotalSalary }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.womenCount !== undefined ||
          originalMetadata?.womenCount !== undefined
        "
      >
        <span class="card__label" i18n>Nombre de femmes</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.womenCount !== metadata.womenCount,
            }"
            >{{ metadata.womenCount }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.womenCount !== metadata.womenCount &&
              originalMetadata.womenCount !== null &&
              originalMetadata.womenCount !== undefined
            "
            >{{ originalMetadata.womenCount }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.menCount !== undefined ||
          originalMetadata?.menCount !== undefined
        "
      >
        <span class="card__label" i18n>Nombre d'hommes</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.menCount !== metadata.menCount,
            }"
            >{{ metadata.menCount }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.menCount !== metadata.menCount &&
              originalMetadata.menCount !== null &&
              originalMetadata.menCount !== undefined
            "
            >{{ originalMetadata.menCount }}</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          (metadata?.hasCollectiveContract !== null &&
            metadata?.hasCollectiveContract !== undefined) ||
          (originalMetadata?.hasCollectiveContract !== null &&
            originalMetadata?.hasCollectiveContract !== undefined)
        "
      >
        <span class="card__label" i18n>Contrat collectif</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.hasCollectiveContract) !==
                  getBooleanLabel(metadata.hasCollectiveContract),
            }"
            >{{ getBooleanLabel(metadata.hasCollectiveContract) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.hasCollectiveContract) !==
                getBooleanLabel(metadata.hasCollectiveContract) &&
              getBooleanLabel(originalMetadata.hasCollectiveContract) !==
                null &&
              getBooleanLabel(originalMetadata.hasCollectiveContract) !==
                undefined
            "
            >{{ getBooleanLabel(originalMetadata.hasCollectiveContract) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.collectiveContract || originalMetadata?.collectiveContract
        "
      >
        <span class="card__label" i18n>Contrat collectif</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.collectiveContract !==
                  metadata.collectiveContract,
            }"
            >{{ metadata.collectiveContract }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.collectiveContract !==
                metadata.collectiveContract &&
              originalMetadata.collectiveContract !== null &&
              originalMetadata.collectiveContract !== undefined
            "
            >{{ originalMetadata.collectiveContract }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.suvaOnly !== null && metadata?.suvaOnly !== undefined) ||
          (originalMetadata?.suvaOnly !== null &&
            originalMetadata?.suvaOnly !== undefined)
        "
      >
        <span class="card__label" i18n>Obligatoirement SUVA</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.suvaOnly) !==
                  getBooleanLabel(metadata.suvaOnly),
            }"
            >{{ getBooleanLabel(metadata.suvaOnly) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.suvaOnly) !==
                getBooleanLabel(metadata.suvaOnly) &&
              getBooleanLabel(originalMetadata.suvaOnly) !== null &&
              getBooleanLabel(originalMetadata.suvaOnly) !== undefined
            "
            >{{ getBooleanLabel(originalMetadata.suvaOnly) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.baseInsurance !== null &&
            metadata?.baseInsurance !== undefined) ||
          (originalMetadata?.baseInsurance !== null &&
            originalMetadata?.baseInsurance !== undefined)
        "
      >
        <span class="card__label" i18n>LAA</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.baseInsurance) !==
                  getBooleanLabel(metadata.baseInsurance),
            }"
            >{{ getBooleanLabel(metadata.baseInsurance) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.baseInsurance) !==
                getBooleanLabel(metadata.baseInsurance) &&
              getBooleanLabel(originalMetadata.baseInsurance) !== null &&
              getBooleanLabel(originalMetadata.baseInsurance) !== undefined
            "
            >{{ getBooleanLabel(originalMetadata.baseInsurance) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.complementaryInsurance !== null &&
            metadata?.complementaryInsurance !== undefined) ||
          (originalMetadata?.complementaryInsurance !== null &&
            originalMetadata?.complementaryInsurance !== undefined)
        "
      >
        <span class="card__label" i18n>LAAC</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.complementaryInsurance) !==
                  getBooleanLabel(metadata.complementaryInsurance),
            }"
            >{{ getBooleanLabel(metadata.complementaryInsurance) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.complementaryInsurance) !==
                getBooleanLabel(metadata.complementaryInsurance) &&
              getBooleanLabel(originalMetadata.complementaryInsurance) !==
                null &&
              getBooleanLabel(originalMetadata.complementaryInsurance) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata.complementaryInsurance)
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isInsuredPersonsEmpty(metadata?.insuredPersons) ||
    metadata?.allCollaboratorsCovered !== undefined ||
    !isInsuredPersonsEmpty(originalMetadata?.insuredPersons) ||
    originalMetadata?.allCollaboratorsCovered !== undefined
  "
>
  <div cardTitle i18n>Cercle des personnes assurées</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div class="card__row">
        <span class="card__label" i18n>Tous les collaborateurs assurés</span>
        <span class="card__value">
          {{ getBooleanLabel(metadata.allCollaboratorsCovered) }}
        </span>
      </div>
      <div class="card__row" *ngFor="let person of metadata?.insuredPersons">
        <span class="card__label">{{ person.fullName }}</span>
        <span *ngIf="person.collaboratorId">
          <a
            (click)="viewCollaborator(person.collaboratorId)"
            class="clickable"
            i18n
            >Voir le collaborateur</a
          >
        </span>
        <span class="card__value" *ngIf="!person.collaboratorId"></span>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isContractInfoEmpty(metadata) || !isContractInfoEmpty(originalMetadata)
  "
>
  <div cardTitle i18n>Informations du contrat</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="metadata?.startDate || originalMetadata?.startDate"
      >
        <span class="card__label" i18n>Date de début</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.startDate | customDate) !==
                  (metadata.startDate | customDate),
            }"
            >{{ metadata.startDate | customDate }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              (originalMetadata.startDate | customDate) !==
                (metadata.startDate | customDate) &&
              (originalMetadata.startDate | customDate) !== null &&
              (originalMetadata.startDate | customDate) !== undefined
            "
            >{{ originalMetadata.startDate | customDate }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.contractDuration || originalMetadata?.contractDuration"
      >
        <span class="card__label" i18n>Durée du contrat</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.contractDuration | customDate) !==
                  (metadata.contractDuration | customDate),
            }"
            >{{ metadata.contractDuration | customDate }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              (originalMetadata.contractDuration | customDate) !==
                (metadata.contractDuration | customDate) &&
              (originalMetadata.contractDuration | customDate) !== null &&
              (originalMetadata.contractDuration | customDate) !== undefined
            "
            >{{ originalMetadata.contractDuration | customDate }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.paymentFrequency || originalMetadata?.paymentFrequency"
      >
        <span class="card__label" i18n>Mode de paiement</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getPaymentFrequencyLabel(originalMetadata.paymentFrequency) !==
                  getPaymentFrequencyLabel(metadata.paymentFrequency),
            }"
            >{{ getPaymentFrequencyLabel(metadata.paymentFrequency) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getPaymentFrequencyLabel(originalMetadata.paymentFrequency) !==
                getPaymentFrequencyLabel(metadata.paymentFrequency) &&
              getPaymentFrequencyLabel(originalMetadata.paymentFrequency) !==
                null &&
              getPaymentFrequencyLabel(originalMetadata.paymentFrequency) !==
                undefined
            "
            >{{
              getPaymentFrequencyLabel(originalMetadata.paymentFrequency)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.splitPaymentFee !== null &&
            metadata?.splitPaymentFee !== undefined) ||
          (originalMetadata?.splitPaymentFee !== null &&
            originalMetadata?.splitPaymentFee !== undefined)
        "
      >
        <span class="card__label" i18n
          >Supplément pour paiement fractionné en %</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.splitPaymentFee !== metadata.splitPaymentFee,
            }"
            >{{ metadata.splitPaymentFee }}%</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.splitPaymentFee !== metadata.splitPaymentFee &&
              originalMetadata.splitPaymentFee !== null &&
              originalMetadata.splitPaymentFee !== undefined
            "
            >{{ originalMetadata.splitPaymentFee }}%</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isCoveragesEmpty(metadata?.coverages) ||
    !isCoveragesEmpty(originalMetadata?.coverages)
  "
>
  <div cardTitle i18n>Prestations assurées</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages?.insuredBenefitsFirstTwoDays !== null &&
            metadata?.coverages?.insuredBenefitsFirstTwoDays !== undefined) ||
          (originalMetadata?.coverages?.insuredBenefitsFirstTwoDays !== null &&
            originalMetadata?.coverages?.insuredBenefitsFirstTwoDays !==
              undefined)
        "
      >
        <span class="card__label" i18n
          >Prestations assurées durant les 2 premiers jours</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.coverages.insuredBenefitsFirstTwoDays
                ) !==
                  getBooleanLabel(
                    metadata.coverages.insuredBenefitsFirstTwoDays
                  ),
            }"
            >{{
              getBooleanLabel(metadata.coverages.insuredBenefitsFirstTwoDays)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.coverages.insuredBenefitsFirstTwoDays
              ) !==
                getBooleanLabel(
                  metadata.coverages.insuredBenefitsFirstTwoDays
                ) &&
              getBooleanLabel(
                originalMetadata.coverages.insuredBenefitsFirstTwoDays
              ) !== null &&
              getBooleanLabel(
                originalMetadata.coverages.insuredBenefitsFirstTwoDays
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.coverages.insuredBenefitsFirstTwoDays
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages?.insuredBenefitsThirdDay !== null &&
            metadata?.coverages?.insuredBenefitsThirdDay !== undefined) ||
          (originalMetadata?.coverages?.insuredBenefitsThirdDay !== null &&
            originalMetadata?.coverages?.insuredBenefitsThirdDay !== undefined)
        "
      >
        <span class="card__label" i18n
          >Prestations assurées dès le 3ème jour</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.coverages.insuredBenefitsThirdDay
                ) !==
                  getBooleanLabel(metadata.coverages.insuredBenefitsThirdDay),
            }"
            >{{
              getBooleanLabel(metadata.coverages.insuredBenefitsThirdDay)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.coverages.insuredBenefitsThirdDay
              ) !==
                getBooleanLabel(metadata.coverages.insuredBenefitsThirdDay) &&
              getBooleanLabel(
                originalMetadata.coverages.insuredBenefitsThirdDay
              ) !== null &&
              getBooleanLabel(
                originalMetadata.coverages.insuredBenefitsThirdDay
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.coverages.insuredBenefitsThirdDay
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.coverages?.waitingDelay ||
          originalMetadata?.coverages?.waitingDelay
        "
      >
        <span class="card__label" i18n>Délai d'attente en jours</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBusinessWaitingDaysLabel(
                  originalMetadata.coverages.waitingDelay
                ) !==
                  getBusinessWaitingDaysLabel(metadata.coverages.waitingDelay),
            }"
            >{{
              getBusinessWaitingDaysLabel(metadata.coverages.waitingDelay)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBusinessWaitingDaysLabel(
                originalMetadata.coverages.waitingDelay
              ) !==
                getBusinessWaitingDaysLabel(metadata.coverages.waitingDelay) &&
              getBusinessWaitingDaysLabel(
                originalMetadata.coverages.waitingDelay
              ) !== null &&
              getBusinessWaitingDaysLabel(
                originalMetadata.coverages.waitingDelay
              ) !== undefined
            "
            >{{
              getBusinessWaitingDaysLabel(
                originalMetadata.coverages.waitingDelay
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages?.maximumInsuredSalary !== null &&
            metadata?.coverages?.maximumInsuredSalary !== undefined) ||
          (originalMetadata?.coverages?.maximumInsuredSalary !== null &&
            originalMetadata?.coverages?.maximumInsuredSalary !== undefined)
        "
      >
        <span class="card__label" i18n>Salaire maximum assuré</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.coverages.maximumInsuredSalary !==
                  metadata.coverages.maximumInsuredSalary,
            }"
            >{{ metadata.coverages.maximumInsuredSalary }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.coverages.maximumInsuredSalary !==
                metadata.coverages.maximumInsuredSalary &&
              originalMetadata.coverages.maximumInsuredSalary !== null &&
              originalMetadata.coverages.maximumInsuredSalary !== undefined
            "
            >{{ originalMetadata.coverages.maximumInsuredSalary }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages?.invalidityPension !== null &&
            metadata?.coverages?.invalidityPension !== undefined) ||
          (originalMetadata?.coverages?.invalidityPension !== null &&
            originalMetadata?.coverages?.invalidityPension !== undefined)
        "
      >
        <span class="card__label" i18n>Rente d'invalidité</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.coverages.invalidityPension
                ) !== getBooleanLabel(metadata.coverages.invalidityPension),
            }"
            >{{ getBooleanLabel(metadata.coverages.invalidityPension) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.coverages.invalidityPension) !==
                getBooleanLabel(metadata.coverages.invalidityPension) &&
              getBooleanLabel(originalMetadata.coverages.invalidityPension) !==
                null &&
              getBooleanLabel(originalMetadata.coverages.invalidityPension) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata.coverages.invalidityPension)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.coverages?.survivalPensionDuration ||
          originalMetadata?.coverages?.survivalPensionDuration
        "
      >
        <span class="card__label" i18n>Rente de survivants : durée</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.coverages.survivalPensionDuration !==
                  metadata.coverages.survivalPensionDuration,
            }"
            >{{ metadata.coverages.survivalPensionDuration }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.coverages.survivalPensionDuration !==
                metadata.coverages.survivalPensionDuration &&
              originalMetadata.coverages.survivalPensionDuration !== null &&
              originalMetadata.coverages.survivalPensionDuration !== undefined
            "
            >{{ originalMetadata.coverages.survivalPensionDuration }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages?.excessSalaries !== null &&
            metadata?.coverages?.excessSalaries !== undefined) ||
          (originalMetadata?.coverages?.excessSalaries !== null &&
            originalMetadata?.coverages?.excessSalaries !== undefined)
        "
      >
        <span class="card__label" i18n
          >Couverture des salaires excédentaires</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.coverages.excessSalaries) !==
                  getBooleanLabel(metadata.coverages.excessSalaries),
            }"
            >{{ getBooleanLabel(metadata.coverages.excessSalaries) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.coverages.excessSalaries) !==
                getBooleanLabel(metadata.coverages.excessSalaries) &&
              getBooleanLabel(originalMetadata.coverages.excessSalaries) !==
                null &&
              getBooleanLabel(originalMetadata.coverages.excessSalaries) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata.coverages.excessSalaries)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages?.coverages &&
            metadata.coverages.coverages.length > 0) ||
          (originalMetadata?.coverages?.coverages &&
            originalMetadata.coverages.coverages.length > 0)
        "
      >
        <span class="card__label" i18n>Prestations assurées</span>
        <div class="d-flex flex-column gap-1 card__value">
          <span>
            <div *ngFor="let coverage of metadata.coverages.coverages">
              {{ getBusinessAccidentInsuranceCoverageLabel(coverage) }}
            </div>
          </span>
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.coverages?.coveragesWaitingDelay ||
          originalMetadata?.coverages?.coveragesWaitingDelay
        "
      >
        <span class="card__label" i18n>Délai d'attente en jours</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBusinessWaitingDaysLabel(
                  originalMetadata.coverages.coveragesWaitingDelay
                ) !==
                  getBusinessWaitingDaysLabel(
                    metadata.coverages.coveragesWaitingDelay
                  ),
            }"
            >{{
              getBusinessWaitingDaysLabel(
                metadata.coverages.coveragesWaitingDelay
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBusinessWaitingDaysLabel(
                originalMetadata.coverages.coveragesWaitingDelay
              ) !==
                getBusinessWaitingDaysLabel(
                  metadata.coverages.coveragesWaitingDelay
                ) &&
              getBusinessWaitingDaysLabel(
                originalMetadata.coverages.coveragesWaitingDelay
              ) !== null &&
              getBusinessWaitingDaysLabel(
                originalMetadata.coverages.coveragesWaitingDelay
              ) !== undefined
            "
            >{{
              getBusinessWaitingDaysLabel(
                originalMetadata.coverages.coveragesWaitingDelay
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages?.privateTreatmentFees !== null &&
            metadata?.coverages?.privateTreatmentFees !== undefined) ||
          (originalMetadata?.coverages?.privateTreatmentFees !== null &&
            originalMetadata?.coverages?.privateTreatmentFees !== undefined)
        "
      >
        <span class="card__label" i18n
          >Frais de traitement en chambre privée</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.coverages.privateTreatmentFees
                ) !== getBooleanLabel(metadata.coverages.privateTreatmentFees),
            }"
            >{{
              getBooleanLabel(metadata.coverages.privateTreatmentFees)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.coverages.privateTreatmentFees
              ) !== getBooleanLabel(metadata.coverages.privateTreatmentFees) &&
              getBooleanLabel(
                originalMetadata.coverages.privateTreatmentFees
              ) !== null &&
              getBooleanLabel(
                originalMetadata.coverages.privateTreatmentFees
              ) !== undefined
            "
            >{{
              getBooleanLabel(originalMetadata.coverages.privateTreatmentFees)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages?.capitalInvalidityLaaSalary !== null &&
            metadata?.coverages?.capitalInvalidityLaaSalary !== undefined) ||
          (originalMetadata?.coverages?.capitalInvalidityLaaSalary !== null &&
            originalMetadata?.coverages?.capitalInvalidityLaaSalary !==
              undefined)
        "
      >
        <span class="card__label" i18n
          >Capital invalidité (350%) sur salaire LAA</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.coverages.capitalInvalidityLaaSalary
                ) !==
                  getBooleanLabel(
                    metadata.coverages.capitalInvalidityLaaSalary
                  ),
            }"
            >{{
              getBooleanLabel(metadata.coverages.capitalInvalidityLaaSalary)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.coverages.capitalInvalidityLaaSalary
              ) !==
                getBooleanLabel(
                  metadata.coverages.capitalInvalidityLaaSalary
                ) &&
              getBooleanLabel(
                originalMetadata.coverages.capitalInvalidityLaaSalary
              ) !== null &&
              getBooleanLabel(
                originalMetadata.coverages.capitalInvalidityLaaSalary
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.coverages.capitalInvalidityLaaSalary
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages?.capitalInvalidityExcessSalary !== null &&
            metadata?.coverages?.capitalInvalidityExcessSalary !== undefined) ||
          (originalMetadata?.coverages?.capitalInvalidityExcessSalary !==
            null &&
            originalMetadata?.coverages?.capitalInvalidityExcessSalary !==
              undefined)
        "
      >
        <span class="card__label" i18n
          >Capital invalidité (350%) sur salaire excédentaire</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.coverages.capitalInvalidityExcessSalary
                ) !==
                  getBooleanLabel(
                    metadata.coverages.capitalInvalidityExcessSalary
                  ),
            }"
            >{{
              getBooleanLabel(metadata.coverages.capitalInvalidityExcessSalary)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.coverages.capitalInvalidityExcessSalary
              ) !==
                getBooleanLabel(
                  metadata.coverages.capitalInvalidityExcessSalary
                ) &&
              getBooleanLabel(
                originalMetadata.coverages.capitalInvalidityExcessSalary
              ) !== null &&
              getBooleanLabel(
                originalMetadata.coverages.capitalInvalidityExcessSalary
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.coverages.capitalInvalidityExcessSalary
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages?.deathBenefitLaaSalary !== null &&
            metadata?.coverages?.deathBenefitLaaSalary !== undefined) ||
          (originalMetadata?.coverages?.deathBenefitLaaSalary !== null &&
            originalMetadata?.coverages?.deathBenefitLaaSalary !== undefined)
        "
      >
        <span class="card__label" i18n>Capital décès sur salaire LAA</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.coverages.deathBenefitLaaSalary
                ) !== getBooleanLabel(metadata.coverages.deathBenefitLaaSalary),
            }"
            >{{
              getBooleanLabel(metadata.coverages.deathBenefitLaaSalary)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.coverages.deathBenefitLaaSalary
              ) !== getBooleanLabel(metadata.coverages.deathBenefitLaaSalary) &&
              getBooleanLabel(
                originalMetadata.coverages.deathBenefitLaaSalary
              ) !== null &&
              getBooleanLabel(
                originalMetadata.coverages.deathBenefitLaaSalary
              ) !== undefined
            "
            >{{
              getBooleanLabel(originalMetadata.coverages.deathBenefitLaaSalary)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages?.deathBenefitExcessSalary !== null &&
            metadata?.coverages?.deathBenefitExcessSalary !== undefined) ||
          (originalMetadata?.coverages?.deathBenefitExcessSalary !== null &&
            originalMetadata?.coverages?.deathBenefitExcessSalary !== undefined)
        "
      >
        <span class="card__label" i18n
          >Capital décès sur salaire excédentaire</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.coverages.deathBenefitExcessSalary
                ) !==
                  getBooleanLabel(metadata.coverages.deathBenefitExcessSalary),
            }"
            >{{
              getBooleanLabel(metadata.coverages.deathBenefitExcessSalary)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.coverages.deathBenefitExcessSalary
              ) !==
                getBooleanLabel(metadata.coverages.deathBenefitExcessSalary) &&
              getBooleanLabel(
                originalMetadata.coverages.deathBenefitExcessSalary
              ) !== null &&
              getBooleanLabel(
                originalMetadata.coverages.deathBenefitExcessSalary
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.coverages.deathBenefitExcessSalary
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages?.apRate !== null &&
            metadata?.coverages?.apRate !== undefined) ||
          (originalMetadata?.coverages?.apRate !== null &&
            originalMetadata?.coverages?.apRate !== undefined)
        "
      >
        <span class="card__label" i18n>Taux AP</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.coverages.apRate) !==
                  getBooleanLabel(metadata.coverages.apRate),
            }"
            >{{ getBooleanLabel(metadata.coverages.apRate) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.coverages.apRate) !==
                getBooleanLabel(metadata.coverages.apRate) &&
              getBooleanLabel(originalMetadata.coverages.apRate) !== null &&
              getBooleanLabel(originalMetadata.coverages.apRate) !== undefined
            "
            >{{ getBooleanLabel(originalMetadata.coverages.apRate) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages?.aanpRate !== null &&
            metadata?.coverages?.aanpRate !== undefined) ||
          (originalMetadata?.coverages?.aanpRate !== null &&
            originalMetadata?.coverages?.aanpRate !== undefined)
        "
      >
        <span class="card__label" i18n>Taux AANP</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.coverages.aanpRate) !==
                  getBooleanLabel(metadata.coverages.aanpRate),
            }"
            >{{ getBooleanLabel(metadata.coverages.aanpRate) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.coverages.aanpRate) !==
                getBooleanLabel(metadata.coverages.aanpRate) &&
              getBooleanLabel(originalMetadata.coverages.aanpRate) !== null &&
              getBooleanLabel(originalMetadata.coverages.aanpRate) !== undefined
            "
            >{{ getBooleanLabel(originalMetadata.coverages.aanpRate) }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isAdditionalCoveragesEmpty(metadata?.additionalCoverages) ||
    !isAdditionalCoveragesEmpty(originalMetadata?.additionalCoverages)
  "
>
  <div cardTitle i18n>Prestations complémentaires</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.additionalCoverages?.relapseCases !== null &&
            metadata?.additionalCoverages?.relapseCases !== undefined) ||
          (originalMetadata?.additionalCoverages?.relapseCases !== null &&
            originalMetadata?.additionalCoverages?.relapseCases !== undefined)
        "
      >
        <span class="card__label" i18n>Reprise des cas de rechute</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.additionalCoverages.relapseCases
                ) !==
                  getBooleanLabel(metadata.additionalCoverages.relapseCases),
            }"
            >{{
              getBooleanLabel(metadata.additionalCoverages.relapseCases)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.additionalCoverages.relapseCases
              ) !==
                getBooleanLabel(metadata.additionalCoverages.relapseCases) &&
              getBooleanLabel(
                originalMetadata.additionalCoverages.relapseCases
              ) !== null &&
              getBooleanLabel(
                originalMetadata.additionalCoverages.relapseCases
              ) !== undefined
            "
            >{{
              getBooleanLabel(originalMetadata.additionalCoverages.relapseCases)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.additionalCoverages?.guaranteedPremiumRate !== null &&
            metadata?.additionalCoverages?.guaranteedPremiumRate !==
              undefined) ||
          (originalMetadata?.additionalCoverages?.guaranteedPremiumRate !==
            null &&
            originalMetadata?.additionalCoverages?.guaranteedPremiumRate !==
              undefined)
        "
      >
        <span class="card__label" i18n
          >Garantie du taux de prime durant le contrat</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.additionalCoverages.guaranteedPremiumRate
                ) !==
                  getBooleanLabel(
                    metadata.additionalCoverages.guaranteedPremiumRate
                  ),
            }"
            >{{
              getBooleanLabel(
                metadata.additionalCoverages.guaranteedPremiumRate
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.additionalCoverages.guaranteedPremiumRate
              ) !==
                getBooleanLabel(
                  metadata.additionalCoverages.guaranteedPremiumRate
                ) &&
              getBooleanLabel(
                originalMetadata.additionalCoverages.guaranteedPremiumRate
              ) !== null &&
              getBooleanLabel(
                originalMetadata.additionalCoverages.guaranteedPremiumRate
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.additionalCoverages.guaranteedPremiumRate
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.additionalCoverages?.grossNegligence !== null &&
            metadata?.additionalCoverages?.grossNegligence !== undefined) ||
          (originalMetadata?.additionalCoverages?.grossNegligence !== null &&
            originalMetadata?.additionalCoverages?.grossNegligence !==
              undefined)
        "
      >
        <span class="card__label" i18n>Couverture de la faute grave</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.additionalCoverages.grossNegligence
                ) !==
                  getBooleanLabel(metadata.additionalCoverages.grossNegligence),
            }"
            >{{
              getBooleanLabel(metadata.additionalCoverages.grossNegligence)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.additionalCoverages.grossNegligence
              ) !==
                getBooleanLabel(metadata.additionalCoverages.grossNegligence) &&
              getBooleanLabel(
                originalMetadata.additionalCoverages.grossNegligence
              ) !== null &&
              getBooleanLabel(
                originalMetadata.additionalCoverages.grossNegligence
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.additionalCoverages.grossNegligence
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.additionalCoverages?.claimTerminationWaiver !== null &&
            metadata?.additionalCoverages?.claimTerminationWaiver !==
              undefined) ||
          (originalMetadata?.additionalCoverages?.claimTerminationWaiver !==
            null &&
            originalMetadata?.additionalCoverages?.claimTerminationWaiver !==
              undefined)
        "
      >
        <span class="card__label" i18n
          >Renonciation à la résiliation sur sinistre</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.additionalCoverages.claimTerminationWaiver
                ) !==
                  getBooleanLabel(
                    metadata.additionalCoverages.claimTerminationWaiver
                  ),
            }"
            >{{
              getBooleanLabel(
                metadata.additionalCoverages.claimTerminationWaiver
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.additionalCoverages.claimTerminationWaiver
              ) !==
                getBooleanLabel(
                  metadata.additionalCoverages.claimTerminationWaiver
                ) &&
              getBooleanLabel(
                originalMetadata.additionalCoverages.claimTerminationWaiver
              ) !== null &&
              getBooleanLabel(
                originalMetadata.additionalCoverages.claimTerminationWaiver
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.additionalCoverages.claimTerminationWaiver
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.additionalCoverages?.premiumSurplusParticipation !==
            null &&
            metadata?.additionalCoverages?.premiumSurplusParticipation !==
              undefined) ||
          (originalMetadata?.additionalCoverages
            ?.premiumSurplusParticipation !== null &&
            originalMetadata?.additionalCoverages
              ?.premiumSurplusParticipation !== undefined)
        "
      >
        <span class="card__label" i18n
          >Participation à l'excédent de primes</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.additionalCoverages
                    .premiumSurplusParticipation
                ) !==
                  getBooleanLabel(
                    metadata.additionalCoverages.premiumSurplusParticipation
                  ),
            }"
            >{{
              getBooleanLabel(
                metadata.additionalCoverages.premiumSurplusParticipation
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.additionalCoverages.premiumSurplusParticipation
              ) !==
                getBooleanLabel(
                  metadata.additionalCoverages.premiumSurplusParticipation
                ) &&
              getBooleanLabel(
                originalMetadata.additionalCoverages.premiumSurplusParticipation
              ) !== null &&
              getBooleanLabel(
                originalMetadata.additionalCoverages.premiumSurplusParticipation
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.additionalCoverages.premiumSurplusParticipation
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.additionalCoverages?.premiumSurplusComputingPeriod ||
          originalMetadata?.additionalCoverages?.premiumSurplusComputingPeriod
        "
      >
        <span class="card__label" i18n
          >Si oui, période de calcul de l'excédent de primes</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.additionalCoverages
                  .premiumSurplusComputingPeriod !==
                  metadata.additionalCoverages.premiumSurplusComputingPeriod,
            }"
            >{{
              metadata.additionalCoverages.premiumSurplusComputingPeriod
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.additionalCoverages
                .premiumSurplusComputingPeriod !==
                metadata.additionalCoverages.premiumSurplusComputingPeriod &&
              originalMetadata.additionalCoverages
                .premiumSurplusComputingPeriod !== null &&
              originalMetadata.additionalCoverages
                .premiumSurplusComputingPeriod !== undefined
            "
            >{{
              originalMetadata.additionalCoverages.premiumSurplusComputingPeriod
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isCurrentInsuranceEmpty(metadata) ||
    !isCurrentInsuranceEmpty(originalMetadata)
  "
>
  <div cardTitle i18n>Assurance actuelle</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.hasInsurance !== null &&
            metadata?.hasInsurance !== undefined) ||
          (originalMetadata?.hasInsurance !== null &&
            originalMetadata?.hasInsurance !== undefined)
        "
      >
        <span class="card__label" i18n>Possède une assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.hasInsurance) !==
                  getBooleanLabel(metadata.hasInsurance),
            }"
            >{{ getBooleanLabel(metadata.hasInsurance) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.hasInsurance) !==
                getBooleanLabel(metadata.hasInsurance) &&
              getBooleanLabel(originalMetadata.hasInsurance) !== null &&
              getBooleanLabel(originalMetadata.hasInsurance) !== undefined
            "
            >{{ getBooleanLabel(originalMetadata.hasInsurance) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.currentInsurer || originalMetadata?.currentInsurer"
      >
        <span class="card__label" i18n>Assureur actuel</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.currentInsurer !== metadata.currentInsurer,
            }"
            >{{ metadata.currentInsurer }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.currentInsurer !== metadata.currentInsurer &&
              originalMetadata.currentInsurer !== null &&
              originalMetadata.currentInsurer !== undefined
            "
            >{{ originalMetadata.currentInsurer }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.hasClaimsLastFiveYears !== null &&
            metadata?.hasClaimsLastFiveYears !== undefined) ||
          (originalMetadata?.hasClaimsLastFiveYears !== null &&
            originalMetadata?.hasClaimsLastFiveYears !== undefined)
        "
      >
        <span class="card__label" i18n
          >A subi des sinistres ces 5 dernières années</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.hasClaimsLastFiveYears) !==
                  getBooleanLabel(metadata.hasClaimsLastFiveYears),
            }"
            >{{ getBooleanLabel(metadata.hasClaimsLastFiveYears) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.hasClaimsLastFiveYears) !==
                getBooleanLabel(metadata.hasClaimsLastFiveYears) &&
              getBooleanLabel(originalMetadata.hasClaimsLastFiveYears) !==
                null &&
              getBooleanLabel(originalMetadata.hasClaimsLastFiveYears) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata.hasClaimsLastFiveYears)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.hasclaimsLastFiveYears !== null &&
            metadata?.hasclaimsLastFiveYears !== undefined) ||
          (originalMetadata?.hasclaimsLastFiveYears !== null &&
            originalMetadata?.hasclaimsLastFiveYears !== undefined)
        "
      >
        <span class="card__label" i18n
          >A subi des sinistres ces 5 dernières années (alternatif)</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.hasclaimsLastFiveYears) !==
                  getBooleanLabel(metadata.hasclaimsLastFiveYears),
            }"
            >{{ getBooleanLabel(metadata.hasclaimsLastFiveYears) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.hasclaimsLastFiveYears) !==
                getBooleanLabel(metadata.hasclaimsLastFiveYears) &&
              getBooleanLabel(originalMetadata.hasclaimsLastFiveYears) !==
                null &&
              getBooleanLabel(originalMetadata.hasclaimsLastFiveYears) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata.hasclaimsLastFiveYears)
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>
